<template>
  <div class="adv-edu-wrap">
    <Header />
    <div class="adv-edu-wrap__banner">
      <img src="../../assets/banner_03.png" />
    </div>
    <div class="adv-edu-wrap__content">
        <div class="adv-edu-wrap__content-title">
            <h2>2022年“宪法宣传周”-学习宣传贯彻党的二十大精神，推动全面贯彻实施宪法</h2>
        </div>
        <div class="adv-edu-wrap__content-img">
            <img src="../../assets/home1.jpg" alt="">
        </div>
        <div class="adv-edu-wrap__content-img">
            <img src="../../assets/home2.jpg" alt="">
        </div>
        <div class="adv-edu-wrap__content-img">
            <img src="../../assets/home3.jpg" alt="">
        </div>
        
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";

export default {
  name: "AdvEdu",
  data() {
    return {
      
    };
  },
  methods: {
   
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style scoped lang="scss">
.adv-edu-wrap {
  min-height: 100%;
  background: rgba(245, 245, 245, 1);
  padding-top: 6rem;

  &__banner {
    img {
      width: 100%;
      margin-bottom: 0;
    }
  }
  &__content{
    width: 75rem;
    margin: 0 auto;
    padding: 3.13rem 6.26rem;
    padding-bottom: 180px;
    background-color: #fff;
    margin-top: 0.1rem;
    text-align: center;
    color: #323232;
    font-size: 1rem;
    overflow: hidden;
    &-title{
        color: red;
        margin-bottom: 1rem;
    }
    &-img{
        img{width: 100%;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/adv-edu/AdvEdu.vue